import { Box, Button, Modal, TextField } from "@mui/material"
import DownloadIcon from "@mui/icons-material/Download";
import SendIcon from '@mui/icons-material/Send';
import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
const style1 = {
    position: 'relative',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    boxShadow: "0px 1px 3px 0px",
    p: 4,
    maxHeight: 600,
    height: 600,
    overflowX: "hidden"

};
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: "0px 1px 3px 0px",
    p: 4,
};


const DocumentPreviewSection = ({ openPreview, handlePreviewClose, prospectInfo }) => {
    console.log(prospectInfo, "======>");
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const [numPages, setNumPages] = useState(null);
    const onDocumentLoadSuccess = ({ numPages }) => {
        console.log("=====>", "asdfasdf")
        setNumPages(numPages);
    };
    return (
        <>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box
                        component="form"
                        sx={{
                            '& > :not(style)': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <TextField
                            id="standard-basic"
                            label="Remark"
                            variant="standard"
                            value={"Enter Remark"}
                        // onChange={handleTextFieldChange}
                        />
                        <Button type="submit" size="small" variant="contained" disabled={true}>Approve</Button>
                        <Button type="submit" size="small" variant="contained" disabled={true}>Reject</Button>
                    </Box>
                </Box>
            </Modal>
            <Modal
                open={openPreview}
                onClose={handlePreviewClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style1}>
                    <div >
                        {prospectInfo?.documentLinks.map((n, i) => {
                            return (
                                n.url.substr(n.url.length - 3) === "pdf" ? (
                                    <div>
                                        <div><h4>{n.fileName}</h4></div>
                                        <div style={{ height: "600px", overflowX: "hidden" }}>
                                            <Document
                                                file={n.url}
                                                onLoadSuccess={onDocumentLoadSuccess}
                                                onLoadError={(error) => console.error('Error loading PDF:', error)}
                                            >
                                                {Array.from({ length: numPages }, (_, index) => (
                                                    <Page
                                                        key={`page_${index + 1}`}
                                                        pageNumber={index + 1}
                                                        renderAnnotationLayer={false}
                                                        renderTextLayer={false}
                                                    // height={270}
                                                    // scale={zoom}

                                                    />
                                                ))}
                                            </Document>
                                        </div>
                                    </div>
                                ) :
                                    <div>
                                        <div><h4>{n.fileName}</h4></div>
                                        <div key={i} style={{ border: "1px solid black", marginBottom: "10px" }}>
                                            <img src={n.url} alt="image" style={{ width: "100%" }} />
                                        </div>
                                    </div>
                            )
                        })}

                    </div>

                    <div style={{ display: "felx" }}>
                        <Button
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            sx={{ m: 1 }}
                            href={prospectInfo?.ehr}
                            target="_blank"
                        >
                            E-Contract
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            sx={{ m: 1 }}
                            href={prospectInfo?.documents}
                            target="_blank"
                        >
                            E-Documents
                        </Button>
                        {/* <Button
                            variant="contained"
                            onClick={() => setOpen(true)}
                        >
                            Add Remark
                        </Button> */}
                    </div>
                </Box>
            </Modal>
        </>
    )
}
export default DocumentPreviewSection